class Monitoring.Models.AcdSetting extends Backbone.Model
  urlRoot: '/keepcon/settings/account_setting/acd_setting'

  defaults:
    active: false
    operators_distribution: 'round_robin_with_assignation_limit'
    operators_distribution_setting: {assignation_limit: 0}
    cases_order: 'oldest_status_change_first'
    acd_by_group: true
    group_names: [],
    settings_by_group: {}
    settings_by_group_and_filter: {}
